import $ from 'jquery';
import qs from 'qs';
import lodash from 'lodash';
import { catalog, catalogFilter } from '../queries';
import { updatePrices } from '../utilities';

const catalogFilterRequest = lodash.debounce(async (params) => {
    const { isSuccess, filters } = await catalogFilter(params);
    if (!isSuccess) {
        return;
    }
    for (let name in filters) {
        $(`.ui-select[data-name="${name}"] .ui-select__item`).hide();
        $(`.ui-select[data-name="${name}"] option`).hide();
        filters[name].forEach(value => {
            $(`.ui-select[data-name="${name}"] .ui-select__item[data-value="${value}"]`).show();
            $(`.ui-select[data-name="${name}"] option[value="${value}"]`).show();

        })
        if (filters[name].length === 0) {
            $(`.ui-select[data-name="${name}"]`).addClass('ui-select--empty');
        } else {
            $(`.ui-select[data-name="${name}"]`).removeClass('ui-select--empty');
        }
    }
}, 200);

const catalogRequest = lodash.debounce(async (params) => {
    $('.page-catalog__items').html(await catalog(params));
    $('.ui-product').trigger('render');
    updatePrices();
}, 200);

const validateFilter = (entry) => {
    let filter = entry;
    try {
        filter = JSON.parse(filter);
    } catch (e) {
        filter = [];
    }
    if (!filter || !Array.isArray(filter)) {
        return [];
    }
    filter = filter.filter(item => {
        if (!Array.isArray(item) || item.length !== 2) {
            return false;
        }
        if (smartFilterNames.indexOf(item[0]) === -1) {
            return false;
        }
        return true;
    });
    return filter;
};

const smartFilterNames = ['segment', 'purpose', 'with', 'form','brand'];
const filterValue = $('.js-form-catalog-filter [name="filter"]').val();
catalogFilterRequest(filterValue ? { 'filter': filterValue } : {});

$('.js-form-catalog-filter select').change(function () {
    const name = $(this).attr('name');
    const value = $(this).val();

    if (smartFilterNames.indexOf(name) === -1) {
        return;
    }

    const filterInput = $('.js-form-catalog-filter [name="filter"]');
    let filter = validateFilter(filterInput.val());

    const index = filter.findIndex(item => item[0] === name);
    if (value.length > 0) {
        if (index < 0) {
            filter.push([name, value]);
        } else {
            filter[index] = [name, value];
            filter = filter.slice(0, index + 1);
        }
    } else {
        if (index > -1) {
            filter = filter.slice(0, index);
        }
    }
    filterInput.val(JSON.stringify(filter));

    smartFilterNames.forEach((name) => {
        if (!filter.find(item => item[0] === name)) {
            $(`.js-form-catalog-filter [name="${name}"]`).val([]).trigger('render');
        }
    });
});

$('.js-form-catalog-filter').on('submit', async function (e) {
    e.preventDefault();
    let { filter, sort, sort_mobile } = $(this).serializeJSON();
    let params = filter && filter !== '[]' ? { filter } : {};
    if (sort_mobile){
        sort = sort_mobile
    }
    if (!!sort ) {
        params = { ...params, sort };
    }

    const search = Object.keys(params).length > 0 ? `?${qs.stringify(params, { encode: false })}` : '';
    history.pushState({}, '', `/catalog/${search}`);
    catalogRequest(params);
    catalogFilterRequest(params);
});

$(document).on('click', '.js-catalog-show-more', async function () {
    const page = $(this).attr('data-value');
    const params = $('.js-form-catalog-filter').serializeJSON();
    if (!params.category) {
        delete params.category;
    }
    if (!params.sort) {
        delete params.sort;
    }

    $('.page-catalog__show-more').remove();

    $('.page-catalog__items').append(await catalog({ page, ...params }));
    $('.ui-product').trigger('render');
    updatePrices();

    let url = new URL(window.location.href);
    url.searchParams.set('pages', page);
    window.history.replaceState({}, '', url);
});

$('.js-page-catalog-filter__reset').click(function () {
    $('.js-form-catalog-filter select').each(function () {
        $(this).val('').trigger('change');
    });
});

$('.js-page-catalog-filter__toggle').click(function () {
    $(this).parents('.page-catalog-filter').toggleClass('page-catalog-filter--closed');

    if ($(this).parents('.page-catalog-filter').hasClass('page-catalog-filter--closed')) {
        $(this).text('Развернуть фильтр');
    } else {
        $(this).text('Свернуть фильтр');
    }
});
